import QuotesList from "../views/QuotesList"
import QuoteDetail from "../views/QuoteDetail"
import QuoteCreate from "../views/QuoteCreate"
import QuoteTransactions from "../views/QuoteTransactions"
import QuoteLogs from "../views/QuoteLogs"
import OffersList from "../views/OffersList"

export default [
	{
		path: "/:tenantId/quotes",
		component: QuotesList,
		name: "QuotesList",
		meta: { featureId: "quotes" }
	},
	{
		path: "/:tenantId/quotes/detail/:id",
		component: QuoteDetail,
		name: "QuoteDetail",
		meta: { featureId: "quotes" },
		props: true
	},
	{
		path: "/:tenantId/quotes/detail/:id/transactions",
		component: QuoteTransactions,
		name: "QuoteTransactions",
		meta: { featureId: "quotes" },
		props: true
	},
	{
		path: "/:tenantId/quotes/detail/:id/offers",
		component: OffersList,
		name: "OffersList",
		meta: { featureId: "quotes" },
		props: true
	},
	{
		path: "/:tenantId/quotes/create",
		component: QuoteCreate,
		name: "QuoteCreate",
		meta: { featureId: "quotes" },
		props: true
	},
	{
		path: "/:tenantId/quotes/detail/logs/:id",
		component: QuoteLogs,
		name: "QuoteLogs",
		meta: { featureId: "quotes" },
		props: true
	}
]
